<template>
    <div v-if="useCoupons">
        <h2>{{ $t('eventRegistration.payment.redeemCoupon') }}</h2>
        <AddCoupon v-if="getInvoiceTotal - getCouponTotal > 0" @newCoupon="addNewToRedeemCoupon">
        </AddCoupon>
        <div class="coupons-grid mt-3">
            <div class="card p-3 m-0" v-for="(couponToRedeem, index) in couponsToRedeem"
                 :key="couponToRedeem.couponId">
                <CouponToRedeem @remove="removeCouponToRedeem(index)" :coupons="couponsToRedeem" :index="index"
                                :alreadyRedeemedAmount="alreadyRedeemedAmount"
                                :invoiceTotal="getInvoiceTotal"></CouponToRedeem>
            </div>
        </div>
        <div class="mt-3" v-if="Array.isArray(redeemedCoupons) && redeemedCoupons.length">
            <h3>{{ $t('eventRegistration.payment.redeemedCoupons') }}</h3>
            <div class="coupons-grid">
                <div class="card p-3 m-0" v-for="redeemedCoupon in redeemedCoupons"
                     :key="redeemedCoupon.redeemId">
                    <RedeemedCoupon :redeemedCoupon="redeemedCoupon"></RedeemedCoupon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";
import registrationPaymentMixin from "@/mixins/registration/registrationPaymentMixin";
import AddCoupon from "@/components/pages/registration/payment/AddCoupon";
import CouponToRedeem from "@/components/pages/registration/payment/CouponToRedeem";
import RedeemedCoupon from "@/components/pages/registration/payment/RedeemedCoupons";

export default {
    name: "Coupons",
    components: {RedeemedCoupon, CouponToRedeem, AddCoupon},
    mixins: [registrationPriceMixin, registrationPaymentMixin],
    methods: {
        addNewToRedeemCoupon(coupon) {
            const couponsToRedeem = this.$cloneDeep(this.couponsToRedeem)
            if (!couponsToRedeem.find((couponToRedeem) => couponToRedeem.couponId === coupon.couponId))
                couponsToRedeem.push(coupon)
            this.couponsToRedeem = couponsToRedeem
        },
        removeCouponToRedeem(index) {
            const couponsToRedeem = this.$cloneDeep(this.couponsToRedeem)
            couponsToRedeem.splice(index, 1)
            this.couponsToRedeem = couponsToRedeem
        }
    },
    computed: {
        useCoupons(){
            //Always use coupons if already coupons redeemed
            if(Array.isArray(this.redeemedCoupons) && this.redeemedCoupons.length) return true;

            if(!this.eventData.useCoupons) return false

            return this.getInvoiceTotal > 0;

        },
        alreadyRedeemedAmount(){
            let amount = 0
            if(!Array.isArray(this.redeemedCoupons)) return amount
            this.redeemedCoupons.forEach((coupon) => amount += coupon.redeemedAmount)
            return amount
        }
    }
}
</script>

<style lang="scss" scoped>
.coupons-grid {
    display: grid;
    gap: map-get($spacers, 2);
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    grid-auto-rows: minmax(150px, auto);

    @include media-breakpoint-down(xs) {
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    }
}
</style>
